import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';

const AppItem = (props) => {
  const { it, id, onClickLinkApp } = props;
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = () => setTooltipOpen(!tooltipOpen);

  const icon = 'nav-icon nav-icon ' + it.description2;

  return (
    <li className="nav-item" key={id}>
      <a
        className="nav-link"
        href="#"
        id={'Tooltip-' + id}
        onClick={(e) => onClickLinkApp(e, it)}
      >
        <i className={icon}></i>
        {it.description1}
      </a>
      {it.value1 && (
        <Tooltip isOpen={tooltipOpen} target={'Tooltip-' + id} toggle={toggle}>
          {it.value1}
        </Tooltip>
      )}
    </li>
  );
};

export default AppItem;
